<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Pensiya kalkulyatoru</h1>

        <p class="note">
          Fərdi şəxsi hesabında yığılan pensiya kapitalını www.e-sosial.az
          saytında qeydiyyatdan keçərək öyrənə bilərsiniz.
        </p>

        <div class="row">
          <div class="col-md-6">
            <p>Pensiyaya neçənci ildə çıxmalısınız:</p>
            <select v-model="pensionYear" @change="caclExperience2006">
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
            </select>

            <p>
              2018-ci il 1 iyul tarixinə sığorta hesabında pensiya kapitalı var?
            </p>
            <div class="d-flex align-items-center">
              <label class="checkbox-wrapper">
                Xeyr
                <input
                  type="radio"
                  value="no"
                  v-model="hesab2018"
                  @change="caclExperience2006"
                />
                <span class="checkmark"></span>
              </label>
              <label class="checkbox-wrapper">
                Bəli
                <input
                  type="radio"
                  value="yes"
                  v-model="hesab2018"
                  @change="caclExperience2006"
                />
                <span class="checkmark"></span>
              </label>
            </div>

            <p>
              1 yanvar 2006-cı ilə qədər iş stajınız (avtomatik hesablanır):
            </p>
            <input type="text" v-model="experience2006" disabled />

            <p>Pensiya kapitalı (e-sosial.az):</p>
            <input type="number" v-model.number="hesab" @input="calc" />

            <p>Pensiya məbləği (təxmini):</p>
            <input type="text" v-model.number="pension" disabled />
          </div>

          <div class="col-md-6">
            <div class="note">
              <p>
                Əmək pensiyasının minimum məbləği:
                <strong>{{ min }} AZN</strong>
              </p>
              <p>
                Fərdi hesabının sığorta hissəsində qeydə alınmış pensiya
                kapitalı əmək pensiyasının minimum məbləğindən az olmayan
                pensiya təminatına imkan verdikdə sığorta stajından asılı
                olmayaraq, bu pensiya təminatına imkan vermədikdə isə azı 25 il
                sığorta stajı olduqda yaşa görə əmək pensiyası hüququ vardır.
              </p>
              <p>
                2019-cu il yanvarın 1-dən etibarən sığortaolunanın əmək
                pensiyası avtomatlaşdırılmış qaydada təyin edilərkən, onun fərdi
                hesabının sığorta hissəsində 2018-ci ilin 1 iyul tarixinə qeydə
                alınmış pensiya kapitalı olduqda (məbləğindən asılı olmayaraq),
                2006-cı il yanvarın 1-dək olan sığorta stajı avtomatik olaraq 25
                ilə bərabər götürülür və bu şəxsə hər ilə görə 306 AZN (istehlak
                qiymətləri indeksinin illik səviyyəsinə uyğun indeksləşdirilir)
                pensiya kapitalı yazılır. 2021-ci ildən başlayaraq 25 illik
                güzəşt hər il 1 il azaldılır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      min: 320, // мин сумма пенсии
      hesab2018: "no", // стаж до 2018 года
      pensionYear: "2025", // год выхода на пенсию
      experience2006: 0, // стаж работы до 2016
      hesab: "", // счет в e-sosial.az
      pension: "0.00 AZN", // итоговая сумма пенсии
    };
  },
  methods: {
    calc: function () {
      // (деньги на счету) / 144 + (стаж до 2006 года * 306) / 144
      // 306 манат с учетом индексации в 2020 году = 741.67488
      // 306 манат с учетом индексации в 2025 году = 1009.8

      this.pension = ((+this.hesab + this.experience2006 * 741.67488) / 144).toFixed(2) + " AZN";
    },
    // расчет стажа работы до 2006 года
    caclExperience2006: function () {
      // если на счету есть деньги
      if (this.hesab2018 === "yes") {
        if (this.pensionYear <= 2020) {
          this.experience2006 = 25;
          this.calc();
        } else {
          // начиная с 2021 года стаж уменьшается на 1 год
          this.experience2006 = 25 - (this.pensionYear - 2020);
          this.calc();
        }
        // если на счету нету денег стаж = 0
      } else {
        this.experience2006 = 0;
        this.calc();
      }
    },
  },
};
</script>

<style scoped>
label {
  cursor: pointer;
}

.checkbox-wrapper {
  display: block;
  position: relative;
  padding-left: 2rem;
  margin-right: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-wrapper input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-wrapper .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #ccc;
  border-radius: 100%;
}
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}
.checkbox-wrapper input:checked ~ .checkmark {
  background-color: #003366;
}
</style>


// WEBPACK FOOTER //
// src/components/calc/Pension.vue